import React, { createContext, useContext, useState } from 'react';
import { ID } from '~/lib/model';
import { useAbility } from '~/lib/ability';
import { AppAdsAbility } from '~/modules/AppAds/ability';

interface SelectedPublisherContextValue {
  selectedPublisherId: ID | null;
  setSelectedPublisherId: (id: ID | null) => void;
}

const SelectedPublisherContext = createContext<SelectedPublisherContextValue>({
  selectedPublisherId: null,
  setSelectedPublisherId: () => {},
});

export const SelectedPublisherProvider = ({ children }: { children: React.ReactNode }) => {
  const ability = useAbility(AppAdsAbility);
  const isPublisherMode = ability.isSeller() || ability.isSelfServe();
  const sellerId = ability.sellerId && ability.sellerId();

  const [selectedPublisherId, setSelectedPublisherId] = useState<ID | null>(
    isPublisherMode && sellerId ? sellerId : null
  );

  return (
    <SelectedPublisherContext.Provider value={{ selectedPublisherId, setSelectedPublisherId }}>
      {children}
    </SelectedPublisherContext.Provider>
  );
};

export const useSelectedPublisher = () => useContext(SelectedPublisherContext);
